<div class="splash-screen" [@fadeInScale]>
  <ds-loader></ds-loader>
  <div class="message-container" *ngIf="message || description">
    <span class="message" *ngIf="message">{{ message }}</span>
    <span class="description" *ngIf="description">{{ description }}</span>
  </div>
</div>
